import React from 'react';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions, { Get } from '../../utils/requisitions/Requisitions';
import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Modal from '../../components/modal.v2/Modal';
import Detail from './Detail';

const URL_EBOOK = WS.ebooks.lista;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    };

  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);
    const {atencao} = this.state.strings;
    const _self = this;

    Requisitions({
      url: URL_EBOOK,
      data: {},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.data,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        /*const doc = new DOMParser().parseFromString(data, 'text/html');
        const body = doc.getElementsByTagName('body')[0];

        document.getElementById("box-iframe").appendChild(body);*/
      },
      error:function(data){

      }
    });
  }

  openDetail(e, url) {
    const {atencao} = this.state.strings;
    let _self = this;

    Get({
      url,
      sucess:function(data){
        Modal.create({
          content: <Detail data={data} />
        });
      }
    });
    e.preventDefault();
  }

  getView() {
    let lista = this.state.lista.map((value, i) =>
        <a href="#" key={i} className='link-detail' onClick={(e) => this.openDetail(e,value.url)}>
          {value.title}
          <i className="fas fa-chevron-right"></i>
        </a>
      );

    return lista;
  }

  render() {
    const view = this.state.loaded ? this.getView() : null;
    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Ebooks"></MainTitle>
              <div>
                {view}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/ebook/Page.js